(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/personal-results/personal-result-individual.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/personal-results/personal-result-individual.js');
"use strict";

const ScoreItem = svs.components.marketplaceCompetition.routeResult.highscore.ScoreItem;
const CompetitionDetails = svs.components.marketplaceCompetition.routeResult.details.CompetitionDetails;
const _svs$components$marke = svs.components.marketplaceCompetition.services.constants.highscoreConstants,
  PositionDirection = _svs$components$marke.PositionDirection,
  HighscoreListType = _svs$components$marke.HighscoreListType;
const FetchState = svs.components.marketplaceCompetition.constants.FetchState;
const PersonalResultsIndividual = _ref => {
  var _individualData$drawR;
  let individual = _ref.individual,
    firstname = _ref.firstname,
    lastname = _ref.lastname;
  if (!individual || individual.status !== FetchState.Fulfilled || !individual.data || Object.keys(individual.data).length === 0) {
    return null;
  }
  const individualData = individual === null || individual === void 0 ? void 0 : individual.data;
  const drawCount = (individualData === null || individualData === void 0 || (_individualData$drawR = individualData.drawResults) === null || _individualData$drawR === void 0 ? void 0 : _individualData$drawR.length) || 0;
  const lastDraw = drawCount > 0 ? individualData.drawResults[individualData.drawResults.length - 1] : undefined;
  const lastDrawCorrects = lastDraw ? lastDraw.correctCount : '-';
  const totalCorrects = individualData.correctCount || 0;
  const positionChangeSinceLast = lastDraw ? lastDraw.positionChangeSinceLast : 0;
  const position = lastDraw ? lastDraw.position : '-';
  let direction = PositionDirection.Unmoved;
  if (positionChangeSinceLast > 0) {
    direction = PositionDirection.Up;
  } else if (positionChangeSinceLast < 0) {
    direction = PositionDirection.Down;
  }
  return React.createElement(ScoreItem, {
    currentScore: lastDrawCorrects,
    Details: () => React.createElement(CompetitionDetails, {
      drawResults: individualData === null || individualData === void 0 ? void 0 : individualData.drawResults,
      numberOfDraws: drawCount,
      type: HighscoreListType.Individual
    }),
    direction: direction,
    isPersonal: true,
    location: individualData === null || individualData === void 0 ? void 0 : individualData.location,
    name: "".concat(firstname, " ").concat(lastname),
    position: position,
    totalScore: totalCorrects
  });
};
setGlobal('svs.components.marketplaceCompetition.routeResult.personalResults.PersonalResultsIndividual', PersonalResultsIndividual);

 })(window);